<template>
    <div class="logic-flow">
        <!-- 辅助工具栏 -->
        <div id="toolbar" class="tool_bar" ref="tool_bar">

            <ul class="ul_tools ">
                <Control ref="control" class="logic-control"
                        v-if="lf"
                        :lf="lf"
                         @setFlowData="setFlowSetData"
                  ></Control>
            </ul>
        </div>


        <div  class="content">

            <el-popover ref="pop_set"
                        placement="bottom-end"
                        popper-class="set_pop_lay"
                        trigger="click">
                <PropertyDialog
                        :subData="subData"
                        :setData="setData"
                        :nodeData="clickNode"
                        :lf="lf"

                ></PropertyDialog>
            </el-popover>


            <!-- 节点面板 -->
        <NodePanel v-if="lf" :lf="lf" :nodeList="nodeList"  @addNodeFinish="addNodeFinish"></NodePanel>
        <!-- 画布 -->
        <div id="LF-view" ref="container"></div>


        </div>


    </div>
</template>


<script>
    import {mapActions} from "vuex"
    import LogicFlow from '@logicflow/core'
    import { Group, Menu, Snapshot, MiniMap , SelectionSelect} from '@logicflow/extension'
    import '@logicflow/core/dist/style/index.css'
    import '@logicflow/extension/lib/style/index.css'
    import NodePanel from './LFComponents/NodePanel'
    import Control from './LFComponents/Control'
    import PropertyDialog from './PropertySetting/PropertyDialog'
    import DataDialog from './LFComponents/DataDialog'
    import customEdge from "./registerNode/customEdge"
    import SubProcess from "./registerNode/registerSubProcess";
    import {
        registerStart,
        registerUser,
        registerEnd,
        registerPush,
        registerDownload,
        registerPolyline,
        registerApproval,
        registerTask,
        registerWait,
        registerConnect,
         registerJu,
        registerSqlNode,
        registerEntity,
        registerPosition,
        registerSubFlow,
        registerCircle


    } from './registerNode'
    const defData = require('./LFComponents/new.json')
    const nodeConfig=require('./LFComponents/config.json')
    export default {
        name: 'ProductManage',
        components: {   NodePanel, Control, PropertyDialog, DataDialog},
        data () {
            return {
                lf: null,
                showAddPanel: false,
                addPanelStyle: {
                    top: 0,
                    left: 0
                },
                setData:{},
                subData:{},
                nodeData: null,
                addClickNode: null,
                clickNode: null,
                dialogVisible: false,
                graphData: null,
                dataVisible: false,
                config: {

                    keyboard: {
                        enabled: true
                    },
                    edgeTextDraggable: true,
                    hoverOutline: false,

                },
                moveData: {},
                nodeList:[],

                nodeType:"flow",
            }
        },
        mounted () {
            this.nodeList=nodeConfig[this.nodeType];
            this.$_initLf()
        },
        methods: {
            $_initLf () {
                // 画布配置
                const lf = new LogicFlow({
                    ...this.config,
                    plugins: [
                        Group,
                        Menu,
                        MiniMap,
                        Snapshot,
                        SelectionSelect
                    ],
                    textEdit: false,
                    background: {
                          backgroundImage: "url("+require('@/assets/grid.svg')+")",
                          backgroundRepeat: "repeat"
                    },
                    container: this.$refs.container,

                })

                this.lf = lf

                this.lf.register(customEdge);
                // this.lf.setDefaultEdgeType("custom-edge");
                // lf.extension.selectionSelect.openSelectionSelect();
                // 设置主题
                lf.setTheme({
                    circle: {
                        stroke: '#377747',
                        strokeWidth: 1,
                        outlineColor: '#88f',
                    },
                    rect: {
                        stroke: '#479a5c',
                        outlineColor: '#88f',
                        strokeWidth: 1
                    },
                    polygon: {
                        stroke: '#32339a',
                        strokeWidth: 1
                    },
                    polyline: {
                        stroke: '#016277',
                        hoverStroke: '#000000',
                        selectedStroke: '#000000',
                        outlineColor: '#88f',
                        strokeWidth: 1
                    },
                    nodeText: {
                        color: '#000000'
                    },
                    edgeText: {
                        color: '#000000',
                        background: {
                            fill: '#f7f9ff'
                        }
                    },
                })
                this.$_registerNode()

            },


            // 自定义
            $_registerNode () {
                registerStart(this.lf)
                registerUser(this.lf)
                registerEnd(this.lf)
                registerPush(this.lf, this.clickPlus, this.mouseDownPlus)
                registerDownload(this.lf)
                registerPolyline(this.lf)
                registerApproval(this.lf)
                registerTask(this.lf)
                registerWait(this.lf)
                registerConnect(this.lf)
                registerJu(this.lf)
                registerSqlNode(this.lf)
                registerEntity(this.lf)
                registerPosition(this.lf)
                registerSubFlow(this.lf)
                registerCircle(this.lf)
                this.lf.register(SubProcess);
                this.$_render()
            },


            $_render (data) {

                this.lf.render(defData)
                this.$_LfEvent()
            },
            $_getData () {
                const data = this.lf.getGraphData()
            },
            $_LfEvent () {
                this.lf.on('node:click', ({data}) => {

                    this.$data.clickNode = data
                    this.$refs.pop_set.showPopper =true;


                })
                this.lf.on('node:add', ({data}) => {
                    this.$data.clickNode = data
                    this.$refs.pop_set.showPopper =true;
                })
                this.lf.on('node:dnd-add', ({data}) => {
                    this.$data.clickNode = data
                    this.lf.graphModel.selectNodeById(data.id)
                    this.$refs.pop_set.showPopper =true;
                })
                this.lf.on('edge:click', ({data}) => {
                    this.$data.clickNode = data
                    this.$refs.pop_set.showPopper =true;
                })
                this.lf.on('element:click', () => {
                    // this.$refs.pop_set.showPopper =false;
                })
                this.lf.on('edge:add', ({data}) => {
                })
                this.lf.on('node:mousemove', ({data}) => {
                    this.moveData = data
                })
                this.lf.on('blank:click', () => {
                    this.$refs.control.closeShow();
                    this.$refs.pop_set.showPopper =false;
                   })
                this.lf.on('connection:not-allowed', (data) => {
                    this.$message({
                        type: 'error',
                        message: data.msg
                    })
                })
                this.lf.on('node:mousemove', () => {

                })
            },


            setFlowSetData(d){
                this.$refs.pop_set.showPopper =false;
                this.setData=d;
            },

            addNodeFinish(d){
                // console.log('node:add', d)
            },


        }
    }
</script>
<style>
    .ul_tools {
        display: flex;
        float: left;
    }

    .logic-flow {
        margin-top: 0px;
        height:100% ;
        width: 100%;
    }

    .tool_bar {
        position: relative;
        float: left;
        width:100%;
        border-bottom: 1px solid #d5d7da;
        z-index: 1000;
    }
    .content {
        position: relative;
        margin: 0;
        padding: 0;
         width: 100%;
        height: calc(100% - 0px);
        overflow: hidden;
    }

    .logic-flow-view {
        height: 100vh;
        position: relative;
    }
    .demo-title{
        text-align: center;
        margin: 20px;
    }
    .logic-control{
        z-index: 2;
    }
    #LF-view{
        width: calc(100% );
        height: 100%;
        outline: none;
        margin-left: 0px;
    }
    .time-plus{
        cursor: pointer;
    }
    .add-panel {
        position: absolute;
        z-index: 11;
        background-color: white;
        padding: 10px 5px;
    }
    .el-drawer__body {
        height: 80%;
        overflow: auto;
        margin-top: -30px;
        z-index: 3;
    }

    @keyframes lf_animate_dash {
        to {
            stroke-dashoffset: 0;
        }
    }
    .form-container {
        padding: 1px;
        box-sizing: border-box;
        box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
        overflow: hidden;

    }
    .set_pop_lay{
        position: absolute;
        margin: 0;
        padding: 0;
        /*top:calc(40px);*/

        left:calc(100% - 360px);
        width: 360px;
        color: #774917;
        background: #f5f5f5;
        /*height: 360px;*/
        opacity: 0.96;
        overflow: hidden;
    }
    .set_pop_info{
        position: absolute;
        margin: 0;
        padding: 0;
        top:calc(30px);
        /*top:calc(100vh - 700px);*/
        left:calc(100% - 600px);
        width: 600px;
        color: #774917;
        background: #f5f5f5;
        height: 660px;
        opacity: 0.96;
        overflow: auto;
    }
    .pop_list_content {
        position: absolute;
        margin: 0;
        padding: 0;
        top:calc(40px);
        left:0px;
        color: #774917;
        background: #a3abb8 !important;
        /*height: 400px;*/
        opacity: 0.9  !important;
        overflow: hidden;
    }


</style>

